import { useSelector } from "react-redux"

export function useIntegration(name) {
  const { active = false, params = {} } =
    useSelector(store => store.profile.integrations[name]) || {}

  return { active, params }
}
